// extracted by css-extract-rspack-plugin
export default {"wrap":"V2Footer-module__wrap"};